module.exports = __webpack_public_path__ + "static/media/icon-report-sidebar-yearly.7bb95395.svg";